import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";

import Carouselcomponent from "./carouselcomponent";
// import CentralDoctraineAndOtherCommonFooterBlock from "../../../components/CentralDoctraineAndOtherCommonFooterBlock/CentralDoctraineAndOtherCommonFooterBlock";

import FtrPrevNxtBtnComponent from "./FtrPrevNxtBtnComponent";

// Import chapter components
import Main_page from "./main_page";
import Chapter_1 from "./chapter_1";
import Chapter_2 from "./chapter_2";
import Chapter_3 from "./chapter_3";
import Chapter_4 from "./chapter_4";
import Chapter_5 from "./chapter_5";
import Chapter_14 from "./chapter_14";
import Chapter_6 from "./chapter_6";
import Chapter_7 from "./chapter_7";
import Chapter_8 from "./chapter_8";
import Chapter_9 from "./chapter_9";
import Chapter_10 from "./chapter_10";
import Chapter_11 from "./chapter_11";
import Chapter_12 from "./chapter_12";
import Chapter_13 from "./chapter_13";

const sliderComponents = [
  Main_page,     // index 0 (skipped on load)
  Chapter_1,     // index 1 (default)
  Chapter_2,
  Chapter_3,
  Chapter_4,
  Chapter_5,
  Chapter_14,
  Chapter_6,
  Chapter_7,
  Chapter_8,
  Chapter_9,
  Chapter_10,
  Chapter_11,
  Chapter_12,
  Chapter_13,
];

export default function Main_chapter({ allComponentViewerState }) {
  const router = useRouter();
  const isInitialLoad = useRef(true);

  // 🔑 Start from Chapter 1
  const [activeIndex, setActiveIndex] = useState(1);

  // 🔄 Read chapter from URL
  useEffect(() => {
    if (!router.isReady) return;

    const chapterFromUrl = parseInt(router.query.chapter, 10);

    if (
      !isNaN(chapterFromUrl) &&
      chapterFromUrl >= 1 &&
      chapterFromUrl < sliderComponents.length
    ) {
      setActiveIndex(chapterFromUrl);
    } else {
      setActiveIndex(1); // default Chapter 1
    }
  }, [router.isReady, router.query.chapter]);

  // 🔄 Sync active chapter to URL
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    const currentChapterInUrl =
      parseInt(router.query.chapter, 10) || 1;

    if (activeIndex !== currentChapterInUrl) {
      router.push(
        {
          pathname: "/ritual-praxis-and-instructions",
          query: { chapter: activeIndex },
        },
        undefined,
        { shallow: true }
      );
    }
  }, [activeIndex]);

  // ▶ Next Chapter
  const nextImage = () => {
    setActiveIndex((prev) =>
      Math.min(prev + 1, sliderComponents.length - 1)
    );
    console.log("test=========>>", sliderComponents.length);
    
  };

  // ◀ Previous Chapter (never go to Main_page)
  const prevImage = () => {
    setActiveIndex((prev) => Math.max(prev - 1, 1));
  };

  return (
    <>
      <Carouselcomponent
        allComponentViewerState={allComponentViewerState}
        activeIndex={activeIndex}
        sliderComponents={sliderComponents}
        onNext={nextImage}
        onPrevious={prevImage}
        totalChapters={sliderComponents.length - 1}
        isInitialLoad={isInitialLoad}
      />

      {/* <CentralDoctraineAndOtherCommonFooterBlock
        allComponentViewerState={allComponentViewerState}
        onNext={nextImage}
        onPrevious={prevImage}
        currentIndex={activeIndex}
        totalChapters={sliderComponents.length - 1}
        buttonText={"chapter"}
      /> */}

      <FtrPrevNxtBtnComponent
        allComponentViewerState={allComponentViewerState}
        onNext={nextImage}
        onPrevious={prevImage}
        currentIndex={activeIndex}
        totalChapters={sliderComponents.length - 1}
        buttonText={"chapter"}
      />
    </>
  );
}
